// src/components/ui/ScrollToTop.jsx — Smooth scroll to top button
import { useState, useEffect } from "react";

export default function ScrollToTop({ t, elevated = false }) {
  const [visible, setVisible] = useState(false);
  const theme = t || {
    bg: "#070B14",
    gold: "#F59E0B",
    border: "rgba(255,255,255,0.1)",
    text: "#F1F5F9",
  };

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes bounceIn {
          0% { transform: scale(0); opacity: 0; }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); opacity: 1; }
        }
        .scroll-btn {
          animation: bounceIn .3s ease;
          transition: transform .2s, background .2s;
        }
        .scroll-btn:hover {
          transform: scale(1.1);
        }
        .scroll-btn:active {
          transform: scale(0.95);
        }
      `}</style>
      <button
        onClick={scrollToTop}
        className="scroll-btn"
        aria-label="Scroll to top"
        title="Scroll to top"
        style={{
          position: "fixed",
          /* Above WhatsApp float (56px + 24px offset + 12px gap) — avoids corner overlap */
          bottom: elevated
            ? "calc(172px + env(safe-area-inset-bottom, 0px))"
            : "calc(92px + env(safe-area-inset-bottom, 0px))",
          right: "calc(24px + env(safe-area-inset-right, 0px))",
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          background: `linear-gradient(135deg, ${theme.gold}, #F97316)`,
          border: "none",
          color: "#070B14",
          fontSize: "1.3rem",
          cursor: "pointer",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 20px rgba(245,158,11,.4)",
        }}
      >
        ↑
      </button>
    </>
  );
}
